import store from '@/store/index';
import { store as localStorage } from '@/utils/common';
import { getApiMethod } from '@/modules/apiSelector'

 /*
  * Save MyStage environment logs
  * - MyStage event logs → store locally then sends when lesson ends (using send-batch-log operation)
  * - Local environment logs → send immediately
  */
export default class LogEventStore {
  async send(newLogInfo) {
    if (!this.checkIfLogShouldBeSent(newLogInfo)) {
      return
    }

    const lessonId = store.state.lessonId;
    const storageKey = `mystage-log-${lessonId}`;

    const existingLogs = Array.isArray(localStorage.getLog(storageKey))
      ? localStorage.getLog(storageKey)
      : [];

    const newLog = { ...newLogInfo, rsn: JSON.stringify(newLogInfo.rsn ?? {}) };
    const allLogs = [newLog, ...existingLogs];

    if (this.isMyStageEventLog(newLogInfo)) {
      localStorage.addLog(storageKey, allLogs);
      return;
    }

    // reset local storage and send logs to API
    localStorage.emptyLog(storageKey);
    const logMyStage = getApiMethod('logMyStage');
    await logMyStage(allLogs);
  }

  /* 
  * Check whether this log should be saved to DB 
  */
  checkIfLogShouldBeSent(log) {
    const sendOperation = ['record-local-environment', 'send-batch-log']
    return sendOperation.includes(log.op) || !!log.rsn?.event_type
  }

  /*
  * Determine if a log is a MyStage event log 
  */
  isMyStageEventLog(log) {
    return !!log.rsn?.event_type
  }
}
